<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="$options.titleText"
    :success-text="successText"
    :action="uploadFile"
    @closed="$emit('closed')"
  >
    <v-overlay :value="isLoading" absolute color="white">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </v-overlay>

    <div v-show="!successMessage">
      <div class="ml-1 mb-2">
        <a @click.stop="onDownloadFile">
          <u>Скачать Шаблон файла</u>
        </a>
      </div>
      <BFileInput
        v-model="file"
        :disabled="isLoading"
        :loading="isLoading"
        :label="'Файл'"
        small-chips
        show-size
        v-on="$listeners || {}"
        @change="onChange"
      >
        <template v-for="(_, key) in $scopedSlots" #[key]="props">
          <slot v-bind="props" :data="getData(props.item)" :name="key" />
        </template>
      </BFileInput>
    </div>

    <div class="pt-5 font-italic">
      <p>
        Столбец АТЕ должен содержать код объекта АТЕ, состояние паспорта которого вы планируете изменить.
      </p>
      <p>
        Стобец Активность должен содержать значение true (активировать паспорт) или false (деактивировать паспорт).
      </p>
    </div>

    <div
      v-if="errorMessage"
      class="error--text ml-8"
      v-text="errorMessage"
    />
  </BModalConfirm>
</template>

<script>
import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import { PassportApi } from '@/api/resources'
import { getErrorMessages } from '@/helpers/getErrorMessages'
import BFileInput from '@/components/forms/BFileInput.vue'
import { downloadLinkByPost } from '@/helpers/downloadBlob'

export default {
  name: 'PassportRefreshModal',
  components: {
    BModalConfirm,
    BFileInput,
  },
  titleText: 'Обновить состояние',
  data: () => ({
    isLoading: false,
    errorMessage: null,
    successText: 'Задача запущена успешно. Результат работы будет отображен в уведомлениях пользователя после ее выполнения.',
    file: null,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close(...args) {
      return this.$refs.modal.close(...args)
    },
    async onDownloadFile() {
      this.errorMessage = null
      this.isLoading = true

      try {
        const api = new PassportApi()
        await downloadLinkByPost(api.downloadTemplateActivateDeactivateURL(), {}, 'Шаблон обновления состояния Паспорта.xlsx')
      } catch (e) {
        this.errorMessage = getErrorMessages(e).join(', ')
      } finally {
        this.isLoading = false
      }
    },
    async uploadFile() {
      const api = new PassportApi()
      await api.uploadTemplateActivateDeactivate(this.file)
      this.close()
      this.$emit('submit')
    },
    onChange(file) {
      this.file = file
    },
  },
}
</script>
